<!-- Importar Miembros -->
<div class="pt-4 border-t border-gray-200 dark:border-gray-700">
  <div class="flex items-center justify-between gap-4">
    <div class="flex-1 min-w-0">
      <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Importar Miembros</h3>
      <p class="text-sm text-gray-500 dark:text-gray-400">Sube un archivo CSV o XLSX con correos electrónicos para agregar contactos masivamente</p>
    </div>
    <button (click)="openModal()"
      class="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white bg-emerald-500 hover:bg-emerald-600 rounded-lg transition-colors shadow-sm">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"/>
      </svg>
      Importar archivo
    </button>
  </div>
</div>

<!-- Import Modal -->
@if (isModalOpen) {
<div class="fixed inset-0 z-modal-top flex items-center justify-center bg-black/50" (click)="closeModal()">
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-lg p-6 mx-4" (click)="$event.stopPropagation()">
    <div class="flex items-center gap-3 mb-6">
      <div class="p-2 bg-emerald-50 dark:bg-emerald-900/20 rounded-xl">
        <svg class="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
        </svg>
      </div>
      <div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">Importar Miembros</h3>
        <p class="text-xs text-gray-500 dark:text-gray-400">Sube un CSV o XLSX con la primera columna conteniendo correos electrónicos</p>
      </div>
    </div>

    @if (!importResult) {
    <div class="space-y-4">
      <label class="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer transition-colors"
        [ngClass]="importFile
          ? 'border-emerald-400 bg-emerald-50/50 dark:bg-emerald-900/10'
          : 'border-gray-300 dark:border-gray-600 hover:border-brand-400 hover:bg-brand-50/30 dark:hover:bg-brand-900/10'">
        @if (importFile) {
        <div class="flex flex-col items-center gap-2">
          <svg class="w-8 h-8 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <span class="text-sm font-bold text-emerald-700 dark:text-emerald-400">{{ importFile.name }}</span>
          <span class="text-xs text-gray-500 dark:text-gray-400">{{ (importFile.size / 1024).toFixed(1) }} KB</span>
        </div>
        } @else {
        <div class="flex flex-col items-center gap-2">
          <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
          </svg>
          <span class="text-sm font-medium text-gray-600 dark:text-gray-300">Haz clic para seleccionar archivo</span>
          <span class="text-xs text-gray-400 dark:text-gray-500">CSV, XLS o XLSX</span>
        </div>
        }
        <input type="file" class="hidden" accept=".csv,.xls,.xlsx" (change)="onFileSelected($event)">
      </label>

      @if (error) {
      <p class="text-sm text-red-600 dark:text-red-400">{{ error }}</p>
      }

      <div class="bg-blue-50 dark:bg-blue-900/10 border border-blue-200 dark:border-blue-800 rounded-xl p-4">
        <h4 class="text-xs font-bold text-blue-700 dark:text-blue-400 mb-2">Formato esperado</h4>
        <ul class="text-xs text-blue-600 dark:text-blue-400 space-y-1">
          <li>La primera columna debe contener los correos electrónicos</li>
          <li>Se buscarán los contactos existentes por email</li>
          <li>Contactos duplicados se ignorarán automáticamente</li>
          <li>Correos no encontrados se reportarán al final</li>
        </ul>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-6">
      <button (click)="closeModal()"
        class="px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
      <button (click)="ejecutarImport()" [disabled]="!importFile || isImporting"
        class="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-emerald-500 rounded-xl hover:bg-emerald-600 transition-colors disabled:opacity-50">
        @if (isImporting) {
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          Importando...
        } @else {
          Importar
        }
      </button>
    </div>
    }

    @if (importResult) {
    <div class="space-y-4">
      <div class="grid grid-cols-2 gap-3">
        <div class="bg-gray-50 dark:bg-gray-800 rounded-xl p-4 text-center">
          <p class="text-2xl font-black text-gray-800 dark:text-gray-200">{{ importResult.totalRows }}</p>
          <p class="text-[10px] font-bold text-gray-500 uppercase tracking-wide mt-1">Total filas</p>
        </div>
        <div class="bg-emerald-50 dark:bg-emerald-900/20 rounded-xl p-4 text-center">
          <p class="text-2xl font-black text-emerald-600 dark:text-emerald-400">{{ importResult.added }}</p>
          <p class="text-[10px] font-bold text-emerald-600/70 uppercase tracking-wide mt-1">Agregados</p>
        </div>
        <div class="bg-amber-50 dark:bg-amber-900/20 rounded-xl p-4 text-center">
          <p class="text-2xl font-black text-amber-600 dark:text-amber-400">{{ importResult.duplicates }}</p>
          <p class="text-[10px] font-bold text-amber-600/70 uppercase tracking-wide mt-1">Duplicados</p>
        </div>
        <div class="bg-red-50 dark:bg-red-900/20 rounded-xl p-4 text-center">
          <p class="text-2xl font-black text-red-600 dark:text-red-400">{{ importResult.errors }}</p>
          <p class="text-[10px] font-bold text-red-600/70 uppercase tracking-wide mt-1">Errores</p>
        </div>
      </div>

      @if (importResult.notFound && importResult.notFound.length > 0) {
      <div class="bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800 rounded-xl p-4">
        <h4 class="text-xs font-bold text-amber-700 dark:text-amber-400 mb-2">Correos no encontrados ({{ importResult.notFound.length }})</h4>
        <div class="max-h-32 overflow-y-auto custom-scrollbar">
          <ul class="text-xs text-amber-600 dark:text-amber-400 space-y-0.5">
            @for (email of importResult.notFound; track email) {
              <li>{{ email }}</li>
            }
          </ul>
        </div>
      </div>
      }

      <div class="flex justify-end">
        <button (click)="closeModal()"
          class="px-4 py-2.5 text-sm font-medium text-white bg-brand-500 rounded-xl hover:bg-brand-600 transition-colors">
          Cerrar
        </button>
      </div>
    </div>
    }
  </div>
</div>
}
